$component-class: 'sn-video-type-4';

.#{$component-class} {
  &__intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-3xl);

    @include desktop {
      margin-bottom: var(--spacing-5xl);
    }

    .me-heading {
      max-width: 774px;
      margin-bottom: 0;

      @include desktop {
        max-width: 806px;
      }
    }

    .me-text {
      max-width: 688px;
    }
  }

  // Animated wrapper — starts invisible; IntersectionObserver adds .is-visible
  // when the element scrolls into the viewport.
  &__video-wrapper {
    width: 100%;
    opacity: 0;
    transform: translateY(1.5rem);
    transition: opacity 0.8s ease, transform 0.8s ease;

    &.is-visible {
      opacity: 1;
      transform: translateY(0);
    }

    // When JS is unavailable (SSR-only context or scripting disabled) always show
    @media (scripting: none) {
      opacity: 1;
      transform: none;
      transition: none;
    }
  }

  // Player container — 16:9 aspect ratio with rounded corners
  &__player {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    border-radius: var(--radius-size-lg);
    background: var(--background-color-brand-primary);

    &--preview {
      cursor: pointer;
    }
  }

  // Poster image shown before playback. This is the me-picture host; it fills the
  // player box absolutely, and its inner .picture/img fill it with object-fit: cover
  // via the me-picture CSS variables.
  &__thumbnail {
    position: absolute;
    inset: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: var(--radius-size-lg);
    overflow: hidden;

    --me-picture-height: 100%;
    --me-picture-img-height: 100%;
    --me-picture-object-fit: cover;
  }

  // Circular play button — centred absolutely over the poster
  &__play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 7.5rem; // 120px
    height: 7.5rem;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: transform 0.2s ease;
    border-radius: 50%;

    &:hover,
    &:focus-visible {
      transform: translate(-50%, -50%) scale(1.08);
      outline: none;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px var(--color-brand-primary-light);
    }
  }

  &__play-icon {
    display: block;
    width: 100%;
    height: 100%;
  }

  // SVG circle — filled with brand primary blue
  &__play-circle {
    fill: var(--color-brand-primary-main);
  }

  // SVG play triangle — white
  &__play-triangle {
    fill: var(--color-neutral-white);
  }

  // Native <video> element — fills the player container
  &__video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    background: var(--color-neutral-black, #000);
  }
}
